import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1190.72471,1368.39529 C1268.65412,1431.64235 1342.40471,1491.38824 1381.82118,1621.15765 L1404.07059,1694.11765 L515.336471,1694.11765 L537.472941,1621.15765 C576.889412,1491.38824 650.64,1431.64235 728.682353,1368.39529 L898.207059,1230.72 C933.783529,1201.80706 985.510588,1201.69412 1021.2,1230.83294 L1190.72471,1368.39529 Z M1333.03059,727.002353 C1468.56,617.110588 1637.29412,480.338824 1637.29412,56.4705882 L1637.29412,0 L282,0 L282,56.4705882 C282,480.338824 450.734118,617.110588 586.263529,727.002353 C675.148235,799.058824 733.764706,846.607059 733.764706,960 C733.764706,1073.39294 675.148235,1120.94118 586.263529,1192.88471 C450.734118,1302.88941 282,1439.66118 282,1863.52941 L282,1920 L1637.29412,1920 L1637.29412,1863.52941 C1637.29412,1439.66118 1468.56,1302.88941 1333.03059,1192.88471 C1244.25882,1120.94118 1185.52941,1073.39294 1185.52941,960 C1185.52941,846.607059 1244.25882,799.058824 1333.03059,727.002353 L1333.03059,727.002353 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHourGlassSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconHourGlassSolid, _Component);

  var _super = _createSuper(IconHourGlassSolid);

  function IconHourGlassSolid() {
    _classCallCheck(this, IconHourGlassSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconHourGlassSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHourGlass",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconHourGlassSolid.displayName = "IconHourGlassSolid";
  return IconHourGlassSolid;
}(Component);

IconHourGlassSolid.glyphName = 'hour-glass';
IconHourGlassSolid.variant = 'Solid';
IconHourGlassSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHourGlassSolid;
export { IconHourGlassSolid };